import React, { useState, useEffect } from 'react';

const LINE1 = 'TECHNOLOGY, REFINED.';

const Background = () => {
  const [displayed, setDisplayed] = useState('');

  useEffect(() => {
    if (displayed.length < LINE1.length) {
      const t = setTimeout(() => setDisplayed(LINE1.slice(0, displayed.length + 1)), 38);
      return () => clearTimeout(t);
    }
  }, [displayed]);

  return (
    <div className="background">
      <div className="scanlines"></div>
      <div className="ascii">
        <pre>
          {`
   ooooooooooooo       .o.       oooooo     oooo oooooooooooo ooooooooo.   ooooo      ooo ooooo ooooooo  ooooo 
   8'   888   \`8      .888.       \`888.     .8'  \`888'     \`8 \`888   \`Y88. \`888b.     \`8' \`888'  \`8888    d8'  
        888          .8"888.       \`888.   .8'    888          888   .d88'  8 \`88b.    8   888     Y888..8P    
        888         .8' \`888.       \`888. .8'     888oooo8     888ooo88P'   8   \`88b.  8   888      \`8888'     
        888        .88ooo8888.       \`888.8'      888    "     888\`88b.     8     \`88b.8   888     .8PY888.    
        888       .8'     \`888.       \`888'       888       o  888  \`88b.   8       \`888   888    d8'  \`888b   
       o888o     o88o     o8888o       \`8'       o888ooooood8 o888o  o888o o8o        \`8  o888o o888o  o88888o 
      
        __      /\\  __   
       / /     / /  \\ \\  
      / /     / /    \\ \\ 
      \\ \\    / /     / / 
       \\_\\  / /     /_/  
             \\/             
          `}
        </pre>
      </div>
      <div className="terminal-text">
        <p><span style={{ color: 'var(--accent-secondary)' }}>&gt;</span> Welcome</p>
        <p className="subtitle">
          {displayed}<span className="blink">_</span>
        </p>
        <p className="error">&gt; CRITICAL_SYSTEM_READY: TAVERNIX_CORE_BOOTED</p>
      </div>
    </div>
  );
};

export default Background;
